export default __webpack_public_path__ + "static/media/70822491.e22bd3ca.jpeg";